
















































































































































































import { readUserProfile } from '@/store/main/getters';
import { dispatchGetUserTasksResponse, dispatchGetUserTicketsResponse } from '@/store/user_tasks/actions';
import { readUserTicketsResponse } from '@/store/user_tasks/getters';
import { Vue, Component, Prop } from 'vue-property-decorator';
import {FmvAvatar} from 'fmv-avatar';
import { IUserTicket } from '@/interfaces/user_tasks';
import { dispatchGetMyStructureUsers } from '@/store/main/actions';
import NewLeadTaskModal from '@/components/UserTasks/Modals/NewLeadTaskModal.vue';
import CreateTicketModal from '@/components/Tickets/Modals/CreateTicketModal.vue';
import { api } from '@/api';

@Component({
  components: {
    FmvAvatar,
    NewLeadTaskModal,
    CreateTicketModal,
  },
})
export default class TicketsListTable extends Vue {
  // @ts-ignore
  @Prop({required: false, default: ''}) readonly public className: string;
  // @ts-ignore
  @Prop({required: false, default: null}) readonly public userId: number | null;
  // @ts-ignore
  @Prop({required: false, default: null}) readonly public viewAs: number | null;
  public currentPage = 1;
  public perPage = 6;
  public showTicketModal = false;
  public ticketView: IUserTicket | null = null;
  public loadingState = {
    list: false,
  };
  public newTaskModal: boolean = false;
  public newTaskTicketID: number | null = null;
  public newTicketModal: boolean = false;

  public async mounted() {
    this.loadingState.list = true;
    await dispatchGetUserTicketsResponse(
      this.$store, {
        rowQuery: `?page=${this.currentPage}&page_size=${this.perPage}`,
        data: {
          // @ts-ignore
          user_id: this.userId,
          view_user_id: this.viewAs,
        },
      },
    );
    this.loadingState.list = false;
  }

  get ticketsList() {
    return readUserTicketsResponse(this.$store);
  }

  public async handleChangePage(page) {
    this.loadingState.list = true;
    this.currentPage = page;
    await dispatchGetUserTicketsResponse(
      this.$store, {
        rowQuery: `?page=${this.currentPage}&page_size=${this.perPage}`,
        data: {
          // @ts-ignore
          user_id: this.userId,
          view_user_id: this.viewAs,
        },
      },
    );
    this.loadingState.list = false;
  }

  public handleViewTicketOpen(ticket) {
    this.ticketView = ticket;
    this.showTicketModal = true;
  }

  public handleViewTicketClose() {
    this.ticketView = null;
    this.showTicketModal = false;
  }

  public handleOpenNewLeadTaskForm(userID) {
    this.newTaskTicketID = userID;
    this.newTaskModal = true;
  }

  public handleOpenNewTicketForm() {
    this.newTicketModal = true;
  }

  public handleCloseSuccessNewLeadTaskModal() {
    this.newTaskModal = false;
    this.newTaskTicketID = null;
    if (this.userId) {
      this.handleChangePage(this.currentPage);
      dispatchGetMyStructureUsers(
        this.$store, {
          rowQuery: `?page=${1}&page_size=${6}`,
          data: {search: ''},
        },
      );
      dispatchGetUserTasksResponse(
        this.$store, {
          rowQuery: `?page=${1}&page_size=${6}`,
          data: {
            mode: 'today',
            // @ts-ignore
            linker_user_id: this.userId,
          },
        },
      );
    }
  }

  public handleCloseSuccessNewTicketModal() {
    this.newTicketModal = false;
    this.handleChangePage(this.currentPage);
  }

  public handleCloseNewTicketForm() {
    this.newTicketModal = false;
  }

  public handleCloseNewLeadTaskModal() {
    this.newTaskModal = false;
    this.newTaskTicketID = null;
  }

  public handleRejectTicket(ticketID) {
    // @ts-ignore
    this.$swal({
      // @ts-ignore
      title: this.$t('Do you confirm rejection?'),
      // icon: 'warning',
      buttons: {
        cancel: {
          // @ts-ignore
          text: this.$t('Cancel'),
          value: false,
          visible: true,
          className: 'btn btn-secondary',
          closeModal: true,
        },
        confirm: {
          // @ts-ignore
          text: this.$t('Confirm'),
          value: true,
          visible: true,
          className: 'btn btn-primary',
          closeModal: true,
        },
      },
    }).then(async (value) => {
      if (value) {
        try {
          const response = await api.rejectResponsibleTicket(
            this.$store.getters.token, {ticket_id: ticketID},
          );
          // @ts-ignore
          this.showToast(this, this.$t('Ticket rejected successfully'));
          this.handleChangePage(this.currentPage);
          dispatchGetMyStructureUsers(
            this.$store, {
              rowQuery: `?page=${1}&page_size=${6}`,
              data: {search: ''},
            },
          );
          dispatchGetUserTasksResponse(
            this.$store, {
              rowQuery: `?page=${1}&page_size=${6}`,
              data: {
                mode: 'today',
                // @ts-ignore
                linker_user_id: this.userId,
              },
            },
          );
        } catch (e) {
          // @ts-ignore
          if (e.response.data && e.response.data.ticket_id) {
            // @ts-ignore
            this.showToast(this, e.response.data.ticket_id[0], 'error');
          } else {
            // @ts-ignore
            this.showToast(this, this.$t('Error'), 'error');
          }
        }
      }
    });
  }

  get ticketsFields() {
    return [
      {
        key: 'actions',
        label: '',
        sortable: false,
        class: 'width-1',
      },
      {
        key: 'user',
        label: this.$t('Full name short'),
        sortable: true,
      },
      {
        key: 'source',
        label: this.$t('Source'),
        sortable: true,
      },
      {
        key: 'type',
        label: this.$t('Type'),
        sortable: true,
      },
      {
        key: 'status_display',
        label: this.$t('Status'),
        sortable: true,
      },
      {
        key: 'created_at',
        label: this.$t('Created'),
        sortable: true,
      },
    ];
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }

  get available() {
    if (this.viewAs) {
      return true;
    }
    const groups = [
      'Менеджеры - Консультирование', 'Менеджеры - Партнерство', 'Админы',
      'Руководитель отдела консультантов',
      "Руководитель отдела консультирования",
      "Руководитель партнерского отдела",
      "Менеджер отдела консультирования",
      "Менеджер партнерского отдела",
      "Консультант отдела консультирования",
      "Консультант партнерского отдела",
      "Администратор отдела консультирования",
      "Администратор партнерского отдела",
    ];
    if (this.userProfile) {
      for (const [key, value] of Object.entries(groups)) {
        // @ts-ignore
        if (this.userProfile.groups.includes(value)) {
          return true;
        }
      }
    }
    return false;
  }

}
